import { requestApi } from "./axiosHelper";

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1";

const testimonialEP = rootUrl + "/testimonials";

const testimonialAPI = {
  // Create a new testimonial
  createNewTestimonial: async (obj) => {
    const axiosData = {
      url: `${testimonialEP}/create`,
      method: "post",
      data: obj,
    };
    try {
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // Fetch all testimonials or by ID
  fetchTestimonials: async (_id) => {
    try {
      const axiosData = {
        url: _id ? `${testimonialEP}/${_id}` : testimonialEP,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // Fetch testimonials by category or type
  fetchByCategoryOrType: async (params) => {
    try {
      const axiosData = {
        url: `${testimonialEP}?${params}`,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // Update a testimonial by ID
  updateTestimonial: async (_id, obj) => {
    try {
      const axiosData = {
        url: `${testimonialEP}/edit/${_id}`,
        method: "patch",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // Delete a testimonial by ID
  deleteTestimonial: async (_id) => {
    try {
      const axiosData = {
        url: `${testimonialEP}/${_id}`,
        method: "delete",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },
};

export default testimonialAPI;
